import { useRef, useEffect } from 'react';

export const BlurredScoreCanvas = ({ text = "100" }) => {
  const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current
        if (!canvas) return

        const ctx = canvas.getContext('2d')

        // Adjust canvas size for clarity and scaling
        const width = 52
        const height = 34
        canvas.width = width
        canvas.height = height

        ctx.clearRect(0, 0, width, height)

        ctx.font = "bold 28px sans-serif"
        ctx.fillStyle = "#00C1FF"
        ctx.shadowColor = "#00C1FF"
        ctx.shadowBlur = 6
        ctx.textAlign = "left"
        ctx.textBaseline = "middle"
        ctx.fillText(text, 2, height / 2)
    }, [text])

    return (
        <canvas
            ref={canvasRef}
            style={{
                display: "inline-block",
                verticalAlign: "middle",
            }}
        />
    )
}

export const SecondaryBlurredScoreCanvas = ({ text = "100" }) => {
  const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current
        if (!canvas) return

        const ctx = canvas.getContext('2d')

        // Adjust canvas size for clarity and scaling
        const width = 22
        const height = 19
        canvas.width = width
        canvas.height = height

        ctx.clearRect(0, 0, width, height)

        ctx.font = "bold 16px sans-serif"
        ctx.fillStyle = "#FFF"
        ctx.shadowColor = "#FFF"
        ctx.shadowBlur = 6
        ctx.textAlign = "left"
        ctx.textBaseline = "middle"
        ctx.fillText(text, 2, height / 2)
    }, [text])

    return (
        <canvas
            ref={canvasRef}
            style={{
                display: "inline-block",
                verticalAlign: "middle",
            }}
        />
    )
}

